import {ClientInfosSummary} from "./client-informations-summary";
import {EmployeeSummary} from "./employee-summary";

export class OpportunitySummary {
    client?: ClientInfosSummary;
    employee?: EmployeeSummary;
    
    constructor(client: ClientInfosSummary, employee: EmployeeSummary) {
        this.client = client;
        this.employee = employee;
    }
}
